import { useAuth } from '@/contexts/AuthContext';

export default function Settings() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <div className="space-y-6">
      <div>
        <div className="label-sm mb-2">Settings</div>
        <h1 className="font-display text-3xl">Account</h1>
      </div>
      <div className="card-tech rounded-lg p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Kv k="Name" v={user.name} />
        <Kv k="Email" v={user.email} />
        <Kv k="Role" v={user.role.toUpperCase()} />
        <Kv k="Auth provider" v={(user.auth_provider || 'jwt').toUpperCase()} />
        <Kv k="Referral code" v={user.referral_code} mono />
        <Kv k="Affiliate tier" v={(user.affiliate_tier || 'bronze').toUpperCase()} />
      </div>
      <button onClick={logout} className="btn-ghost btn-sm" data-testid="settings-logout">Logout</button>
    </div>
  );
}

function Kv({ k, v, mono }) {
  return (
    <div>
      <div className="label-xs">{k}</div>
      <div className={`mt-1 ${mono ? 'font-mono' : ''}`}>{v}</div>
    </div>
  );
}
